import { useMutation, useQueryClient } from '@tanstack/react-query';
import { InitializeCompleteContract, InitializeCompleteResponse } from '@bliks-io/contracts';
import { apiClient } from '../client';
import { authKeys, organizationKeys, dataSyncKeys } from '../query-keys';

export function useCompleteInitialSetup() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => {
      const { data: response } = await apiClient.post<InitializeCompleteResponse>(
        InitializeCompleteContract.path,
        {}
      );
      return response;
    },
    onSuccess: () => {
      // The backend drops the setup snapshot on completion; a cached copy
      // would seed a re-entered wizard step.
      queryClient.removeQueries({ queryKey: dataSyncKeys.setupRows() });
      // Awaited (returned) on purpose: the routing gate reads setupComplete
      // from the profile cache, so navigation after mutateAsync must see the
      // refetched flag.
      return Promise.all([
        queryClient.invalidateQueries({ queryKey: organizationKeys.all }),
        queryClient.invalidateQueries({ queryKey: authKeys.profile() })
      ]);
    }
  });
}
